import { join } from 'node:path';
import type { Directory, File } from '@wix/velo-client';
import { outputFile, outputDir } from '@wix/cli-fs';

export class ProjectFilesService {
  constructor(private projectFolder: string) {}

  addDir = async (file: Directory): Promise<void> => {
    const filePath = this.getFullPath(file);
    await outputDir(filePath);
  };

  saveFile = async (file: File): Promise<void> => {
    const filePath = this.getFullPath(file);
    await outputFile(filePath, file.content);
  };

  private getFullPath = (file: File | Directory) =>
    join(this.projectFolder, file.path);
}
